import React from 'react';
import classNames from 'classnames';
import { Field } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import InputField from 'components/InputField';
import validations from 'validations';

import './ContactNumberField.styles.scss';

type ContactNumberFieldProps = {
  className?: string;
  name?: string;
  label?: string;
  required?: boolean;
};

const ContactNumberField: React.FC<ContactNumberFieldProps> = (props) => {
  const { className, label, required = false, name = 'contactNumber' } = props;

  const classes = classNames('contact-number-field', className);

  const { t } = useTranslation();

  return (
    <Field
      name={name}
      component={InputField}
      className={classes}
      numberStyle="phoneNumber"
      label={label || t('phoneNumber')}
      required={required}
      validate={validations.composeValidators(
        required ? validations.required() : null,
        validations.contactNumber(),
      )}
    />
  );
};

export default ContactNumberField;
